// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1v0MC","errorLogs":"styles_errorLogs__1C_Sv"};